import React, { FormEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { message } from "antd";
import { hideModal } from "../../../../redux/actions/modal";
import CustomSearchDropDown from "../../../../components/CustomHTMLElements/CustomSearchDropDown/CustomSearchableDropdown";

const today = new Date().toISOString().slice(0, 10);
const lastMonth = new Date(new Date());
lastMonth.setDate(lastMonth.getDate() - 30);
const aMonthAgo = lastMonth.toISOString().slice(0, 10);

interface IBlackListSearchParams {
  email?: string;
  phoneNumber?: string;
  bvn?: string;
  nin?: string;
  rcNumber?: string;
  customerType?: string;
  startDate?: string;
  endDate?: string;
}

interface AdvancedBlackListSearchModalProps {
  onCloseModal: () => void;
  onSearch: (params: IBlackListSearchParams) => void;
}

const AdvancedBlackListSearchModal: React.FC<
  AdvancedBlackListSearchModalProps
> = ({ onCloseModal, onSearch }) => {
  const [state, setState] = useState<IBlackListSearchParams>({
    startDate: aMonthAgo,
    endDate: today,
  });

  const dispatch = useDispatch();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    if (state.startDate && state.endDate) {
      const diffTime =
        new Date(state.endDate).valueOf() - new Date(state.startDate).valueOf();

      if (diffTime < 0) {
        message.info("Invalid date range");
        return;
      }
    }

    onSearch(state);
    dispatch(hideModal());
  };

  const handleCustomerTypeChange = (data: { label: string; value: string }) => {
    setState((prev) => ({
      ...prev,
      customerType: data?.value,
    }));
  };

  const customerTypeOptions = [
    { label: "Individual", value: "Individual" },
    { label: "Organisation", value: "Organisation" },
  ];

  const handleClear = () => {
    setState({
      startDate: aMonthAgo,
      endDate: today,
    });
    onSearch({});
    dispatch(hideModal());
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <React.Fragment>
            <h3 className="Modal__title p-b-1">Advanced Search</h3>
            <div id="blacklist-search-form">
              <div className="m-b-30">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 col-sm-12 mt-2">
                      <label htmlFor="email">Email:</label>
                      <input
                        type="email"
                        placeholder="e.g. john.doe@example.com"
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }));
                        }}
                        value={state.email || ""}
                        name="email"
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 mt-2">
                      <label htmlFor="phoneNumber">Phone Number:</label>
                      <input
                        type="text"
                        placeholder="e.g. +2348012345678"
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            phoneNumber: e.target.value,
                          }));
                        }}
                        value={state.phoneNumber || ""}
                        name="phoneNumber"
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 mt-2">
                      <label htmlFor="bvn">BVN:</label>
                      <input
                        type="text"
                        placeholder="e.g. 22334455667"
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            bvn: e.target.value,
                          }));
                        }}
                        value={state.bvn || ""}
                        name="bvn"
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 mt-2">
                      <label htmlFor="rcNumber">RC Number:</label>
                      <input
                        type="text"
                        placeholder="e.g. RC123456"
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            rcNumber: e.target.value,
                          }));
                        }}
                        value={state.rcNumber || ""}
                        name="rcNumber"
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 mt-2">
                      <label htmlFor="nin">NIN:</label>
                      <input
                        type="text"
                        placeholder="e.g. 12345678901"
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            nin: e.target.value,
                          }));
                        }}
                        value={state.nin || ""}
                        name="nin"
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 mt-4">
                      <div className="input-group pt-1">
                        <CustomSearchDropDown
                          label="Customer Type:"
                          onChange={handleCustomerTypeChange}
                          options={customerTypeOptions}
                          name="customerType"
                          isShowLabel
                          inputHeight={50}
                          isAsync={false}
                          labelStyle={{
                            fontSize: "12rem",
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12 mt-4">
                      <label htmlFor="startDate">From:</label>
                      <input
                        type="date"
                        value={state.startDate || ""}
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            startDate: e.target.value,
                          }));
                        }}
                        name="startDate"
                        placeholder="YYYY/MM/DD"
                      />
                    </div>

                    <div className="col-md-6 col-sm-12 mt-4">
                      <label htmlFor="endDate">To:</label>
                      <input
                        type="date"
                        value={state.endDate || ""}
                        className="form-control"
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            endDate: e.target.value,
                          }));
                        }}
                        name="endDate"
                        placeholder="YYYY/MM/DD"
                      />
                    </div>
                  </div>

                  <div className="Form__action-buttons m-t-2">
                    <button
                      type="submit"
                      className="btn zoom-element btn login-btn m-0 mr-auto"
                    >
                      <i className="fa fa-search" /> Search
                    </button>
                    <button
                      type="button"
                      onClick={handleClear}
                      className="btn zoom-element btn login-btn m-0 ml-auto"
                    >
                      <i className="fa fa-times-circle" /> Clear
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default AdvancedBlackListSearchModal;
